export default __webpack_public_path__ + "static/media/cholet13.fc9a2564.jpg";